import type {
	DateRangePickerOptions,
	DateRangeSpecificPickerOption,
	RangeSelectorType,
} from '../types';
import * as dateFns from 'date-fns';
import {utcModifierWrapper} from '@deezer/next/shared/utils/date';

export const getOptions = <T extends RangeSelectorType>(
	type: T,
	options: DateRangePickerOptions<[T]>,
): {minDate: Date; maxDate: Date} & DateRangeSpecificPickerOption<[T]>[T] => {
	const pickerOptions = options.picker?.[type] as any;
	return {
		...pickerOptions,
		minDate: pickerOptions?.minDate || options.minDate,
		maxDate: pickerOptions?.maxDate || options.maxDate,
	};
};

export const getCurrentPitchingWeek = () => {
	const today = new Date();
	const now = dateFns.isFriday(today)
		? utcModifierWrapper(today, dateFns.endOfDay, 'UTC')
		: utcModifierWrapper(dateFns.nextFriday(today), dateFns.endOfDay, 'UTC');
	const fromDate = dateFns.isSaturday(today)
		? utcModifierWrapper(today, dateFns.startOfDay, 'UTC')
		: utcModifierWrapper(
				dateFns.previousSaturday(today),
				dateFns.startOfDay,
				'UTC',
			);
	return {now, fromDate};
};

export const getNextPitchingWeek = () => {
	const today = new Date();
	const nextWeekDay = dateFns.addWeeks(today, 1);

	const now = dateFns.isFriday(nextWeekDay)
		? utcModifierWrapper(nextWeekDay, dateFns.endOfDay, 'UTC')
		: utcModifierWrapper(
				dateFns.nextFriday(nextWeekDay),
				dateFns.endOfDay,
				'UTC',
			);
	const fromDate = dateFns.isSaturday(nextWeekDay)
		? utcModifierWrapper(nextWeekDay, dateFns.startOfDay, 'UTC')
		: utcModifierWrapper(
				dateFns.previousSaturday(nextWeekDay),
				dateFns.startOfDay,
				'UTC',
			);

	return {now, fromDate};
};
